module.exports = __webpack_public_path__ + "img/header-img-styria.1be90552.jpg";